/**
 * Abstract converter generator. Creates a text converter with the
 * specified type and matchElement function. Returns an immutable
 * converter object.
 *
 * @typedef Obj
 * @property {string} type Type of the converter (ie paragraph, preamble, etc)
 * @property {Function} matchElement Optional matchElement function that returns true or false
 *
 * @param {Obj}
 */
const TextConverter = ({type, exportAsType = null, matchElement = null}) => {
    return Object.freeze({
        tagName: 'element',
        type: type,
        matchElement: matchElement || _matchElement,
        import: _import,
        export: (node, el, converter) => {
            _export(node, el, converter, exportAsType)
        }
    })
}

/**
 * Default matchElement function
 */
function _matchElement() {
    return false
}

/**
 * Text import function, converts from dom structure to node.
 *
 * Saves original type in order to preserve it when unsupported text are
 * encountered as those nodes are of type "unsupportedtextnode" internally.
 */
function _import(el, node, converter) {
    const state = converter.state

    if (typeof node.originalType === 'string') {
        node.originalType = el.getAttribute('type')
    }

    state.trimWhitespaces = true
    node.content = converter.annotatedText(
        el,
        [node.id, 'content']
    )
    state.trimWhitespaces = state.trimWhitespaces
}

/**
 * Text export function, converts from node to dom structure.
 *
 * Preserves originalType if exists (for nodes of type "Unsupportedtextnode").
 */
function _export(node, el, converter, exportAsType) {
    let type = exportAsType
    if (!type) {
        type = (typeof node.originalType === 'string') ? node.originalType : node.type
    }

    el.attr('type', type).append(
        converter.annotatedText([node.id, 'content'])
    )
}

export {TextConverter}
